import { ClientCartAction, type ClientCartActionCartRef, SwarovskiOptikClientCart } from "@swo/storefront";
import { MyCartAction_ChangeLineItemAmount } from "../../../types";
import { Either } from "fp-ts/es6/Either";
import { performCartAction } from "../perform-cart-action";

import { SwarovskiOptikErrorClientResponse } from "../../types";

export const changeLineItemAmount = (
  token: string,
  localeCode: string,
  segmentKey: string,
  cart: SwarovskiOptikClientCart,
  data: Pick<MyCartAction_ChangeLineItemAmount, "change">,
): Promise<Either<SwarovskiOptikErrorClientResponse, SwarovskiOptikClientCart>> => {
  const cartRef: ClientCartActionCartRef = {
    id: cart.id,
    version: cart.version,
  };

  const actionBody: ClientCartAction = {
    tag: "change-line-item-amount",
    cartRef: cartRef,
    change: data.change,
  };

  return performCartAction(token, localeCode, segmentKey)(actionBody);
};
